import React from 'react';
import { ExclamationTriangleIcon, ReloadIcon } from '@radix-ui/react-icons';

/**
 * Without this, any render-time throw leaves the user on a blank white page
 * with no header, no error and no way back.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
    this.handleRetry = this.handleRetry.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled render error:', error, info?.componentStack);
  }

  handleRetry() {
    this.setState({ error: null });
  }

  render() {
    if (!this.state.error) {
      return this.props.children;
    }

    return (
      <div className="app-error-state">
        <ExclamationTriangleIcon className="app-error-icon" />
        <h2>Something broke on this screen</h2>
        <p>The page ran into an unexpected error. Your account and credits are unaffected.</p>
        <p className="app-error-detail">{String(this.state.error?.message || this.state.error)}</p>
        <div className="app-error-actions">
          <button type="button" className="btn btn-primary" onClick={this.handleRetry}>
            <ReloadIcon style={{ marginRight: '8px' }} />
            Try again
          </button>
          <button type="button" className="btn btn-secondary" onClick={() => window.location.assign('/')}>
            Back to Dashboard
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
